<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">油站详情</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <div class="jiayoudetailtop"></div>
    <!--    <div class="jiayoudetailcenter"></div> -->
    <div class="jiayoudetailcenter1">
      <div class="jiayoudetialbox">
        <div class="jiayouboxtop">
          <div class="jiayouname">{{stationDetail.name}}</div>
          <div class="jiayoujulibox">
            <img class="jiayoujuliicon" src="../../../static/juli.png" />
            <div class="jiayoujuli">{{stationDetail.distance}}</div>
          </div>
        </div>
        <div class="jiayouaddress">{{stationDetail.address}}</div>
        <div class="jiayoupricedetail"><span style="font-size: 15px;">￥</span>0.0</div>
        <div class="jiayouboxbottom">
          <img class="jiayoudetailicon24" src="../../../static/24xiaoshi.png" />
          <div class="jiayoudetailiconbox" @click="openjiayoudetail">
            <div class="jiayoudetailtext">详情</div>
            <img class="jiayoudetailicon" src="../../../static/xiagengduohei.png" />
          </div>
        </div>
      </div>
      <div class="jiayoudetialbox">
        <div class="jiayoutitle">请选择油枪号</div>
        <div class="youqianglist">
          <div class="youqiangbox1" @click="openyouqiang">
            <div class="youqiangname1">{{oilName ? oilName : '请选择油号'}}</div>
            <img class="jiayoudetailicon" src="../../../static/xiagengduohei.png" />
          </div>
          <div class="youqiangbox1" v-if="gunNo">
            <div class="youqiangname1">{{gunNo}}</div>
            <!-- <img class="jiayoudetailicon" src="../../../static/xiagengduohei.png" /> -->
          </div>
        </div>
        <div class="jiayoutitle">请输入金额</div>
        <div class="jiayouinputbox">
          <div class="jiayoupriceicon">￥</div>
          <input class="jiayouinput" @input="selectprice($event)" v-model="stationpriceNum" placeholder="请输入金额" />
        </div>
        <div class="youqianglist">
          <div :class="item.checkprice ? 'youqiangbox' : 'youqiangbox1' " @click="changeprice(index)" v-for="(item,index) in pricelist">
            <div class="youqiangname1">￥<span style="font-weight: bold;font-size: 19px;">{{item.price}}</span></div>
          </div>
          <!-- <div class="youqiangbox1">
            <div class="youqiangname1">￥<span style="font-weight: bold;font-size: 19px;">300</span></div>
          </div> -->
        </div>
        <div class="youhuibox">
          <div class="youhuititle">直降优惠</div>
          <div class="youhuivalue">{{stationprice.promotionAmount ? stationprice.promotionAmount : '0'}}￥</div>
        </div>
        <div class="youhuibox">
          <div class="youhuititle">服务费</div>
          <div class="youhuivalue">{{stationprice.serviceFee ? stationprice.serviceFee : '0'}}￥</div>
        </div>
      </div>
      <div class="detailnone"></div>
    </div>
    <div class="jiayoudetailbottom">
      <div class="jiayoupricebox">实付金额：<span style="color: #029DFF;">￥{{stationprice.realPrice ? stationprice.realPrice : '0'}}</span></div>
      <div class="jiayoudetailzhifubotton" @click="payamount()">去支付</div>
    </div>
    <!-- 弹出层 商家详情 开始 -->
    <van-popup v-model:show="jiayouDetailShow" closeable round position="bottom" :style="{ height: '66%' }">
      <div class="youzhandetailname">油站详情</div>
      <div class="jiayouzhancenter">
        <div class="jiayouname" style="margin-bottom: 8px;">油站服务</div>
        <img class="jiayoudetailicon24" style="margin-bottom: 44px;" src="../../../static/24xiaoshi.png" />
        <div class="jiayouname" style="margin-bottom: 8px;">营业资质</div>
        <div class="jiayouzhanmesg">以上信息均为商家提供，具体以相关主管登记部门为准。经营者需确保信息真实有效，如与实际不符或发生变更，请联系平台更新</div>
        <div class="jiayouzhanimgs">
          <!-- <img class="jiayouzhanimg" src="" /> -->
        </div>
      </div>
    </van-popup>
    <!-- 弹出层 商家详情 结束 -->
    <!-- 弹出层 油枪号 开始 -->
    <van-popup v-model:show="youqiangShow" closeable round position="bottom" :style="{ height: '76%' }">
      <div class="youzhandetailname">选择油枪号</div>
      <div class="youqiangtip">请先确认油号是否正确，并向加油员确认加油枪号</div>
      <div class="jiayouzhancenter">
        <div class="jiayouname" style="margin-bottom: 18px;">油号</div>
        <div class="qianghaolist">
          <div @click="changeyouhao(index)" :class="item.select ? 'qianghaobox' : 'qianghaobox1'" v-for="(item,index) in youhaonum">{{item.oilName}}</div>
        </div>
        <div class="jiayouname" style="margin-bottom: 18px;">枪号</div>
        <div class="qianghaolist">
          <div @click="changeyouqiang(index)" :class="item.check ? 'qianghaobox' : 'qianghaobox1'" v-for="(item,index) in youqiang">{{item.gunNo}}</div>
        </div>
      </div>
    </van-popup>
    <!-- 弹出层 油枪号 结束 -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        jiayouDetailShow: false,
        youqiangShow: false,
        youhaonum: [],
        youqiang: [],
        id: "",
        lng: "", //经度
        lat: "", //纬度
        stationDetail: {},
        oilName: "",
        gunNo: "",
        stationprice: {},
        pricelist: [{
          price: "200",
          pricenum: 200,
          checkprice: false
        }, {
          price: "300",
          pricenum: 300,
          checkprice: false
        }],
        stationpriceNum: 0,
        buttonClicked: false, // 防止支付重复点击,默认为false
        mobile: "", //手机号
        userInfo:{},
        amount:"",//余额
      }
    },
    created() {
      console.log("id", this.$route.query.id)
      if (this.$route.query.id) {
        this.id = this.$route.query.id

        if (this.$route.query.lng) {
          this.lng = this.$route.query.lng
        } else {
          this.lng = ""
        }
        if (this.$route.query.lat) {
          this.lat = this.$route.query.lat
        } else {
          this.lat = ""
        }
        this.request("oilStationDetail", {
          id: this.id,
          lng: this.lng,
          lat: this.lat
        })
      } else {
        this.id = ""
      }
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      openjiayoudetail() {
        this.jiayouDetailShow = true
      },
      openyouqiang() {
        let that = this
        this.youqiangShow = true
        this.stationDetail.prices.map(v => {
          that.$set(v, 'selcet', false)
          return v
        })
        this.youhaonum = this.stationDetail.prices
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true;
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === "number") {
            setTimeout(() => {
              this.buttonClicked = false;
            }, duration);
          }
          resolve(true);
        });
      },
      payamount() {

        let that = this
        this.buttonClickedFun(1000) // 防止重复点击
        // if ((!this.mobile)) {
        //   Dialog.confirm({
        //       title: '提示',
        //       message: '请先绑定手机',
        //     })
        //     .then(() => {
        //       that.$router.push({
        //         path: "/changePhoneNum"
        //       })
        //     })
        //     .catch(() => {
        //       return false;
        //     });
        // }
        var order_param = {}
        order_param.gas_id = this.id
        order_param.oil_name = this.oilName
        order_param.gun_id = this.gunNo
        order_param.amount = this.stationprice.realPrice
        // if (this.phoneNum) {
        //   order_param.recharge_number = this.phoneNum
        // }
        // 判断用户是微信支付还是余额支付
        // console.log()
        // if (that.isWeixinPay) {
        //   Dialog.confirm({
        //       title: '提示',
        //       message: '是否用微信支付?',
        //     })
        //     .then(() => {
        //       order_param.pay_type = 'wechatpay'
        //       that.request('WxunifiedOrder', order_param)
        //     })
        //     .catch(() => {
        //       return false;
        //     });
        // } else {
        if (parseFloat(that.amount) < parseFloat(this.stationprice.realPrice)) {
          Dialog.confirm({
              title: '提示',
              message: '积分不足，前往充值？',
            })
            .then(() => {
              that.$router.push({
                path: "/account"
              })
            })
            .catch(() => {
              return false;
            });
        } else {
          Dialog.confirm({
              title: '提示',
              message: '是否用余额支付?',
            })
            .then(() => {
              order_param.pay_type = 'balance' //余额卡券支付
              that.request('sxoilorder', order_param)
            })
            .catch(() => {
              return false;
            });
        }
        // }
      },
      //改变价格
      changeprice(indexStr) {
        let that = this
        let pricelist = this.pricelist
        pricelist.map((item, index) => item.checkprice = index == indexStr)
        this.pricelist = pricelist
        this.stationpriceNum = this.pricelist[indexStr].pricenum
      },
      selectprice(e) {
        let that = this
        if (e.target.value == 200) {
          this.pricelist[0].checkprice = true
          this.pricelist[1].checkprice = false
        } else if (e.target.value == 300) {
          this.pricelist[1].checkprice = true
          this.pricelist[0].checkprice = false
        } else {
          this.pricelist[1].checkprice = false
          this.pricelist[0].checkprice = false
        }
        this.stationpriceNum = e.target.value
        this.request("stationprice",{
          gas_id:this.id,
          oil_name:this.oilName,
          price:this.stationpriceNum
        })
      },
      //改变油号
      changeyouhao(indexStr) {
        let that = this
        let youhaonums = this.youhaonum
        youhaonums.map((item, index) => item.select = index == indexStr)
        this.youhaonum = youhaonums
        this.youhaonum[indexStr].gunNos.map(v => {
          that.$set(v, 'check', false)
          return v
        })
        this.oilName = this.youhaonum[indexStr].oilName
        this.youqiang = this.youhaonum[indexStr].gunNos
        console.log("this.youqiang", this.youqiang)
      },
      //改变油枪
      changeyouqiang(indexStr) {
        let that = this
        let youqiangs = this.youqiang
        youqiangs.map((item, index) => item.check = index == indexStr)
        this.youqiang = youqiangs
        this.gunNo = this.youqiang[indexStr].gunNo
        this.youqiangShow = false
      },
      request(type = "", requestData = {}) {
        let that = this;
        let data = {};
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code == 0) {
                console.log("用户信息", res.data)
                that.userInfo = res.data
                that.mobile = res.data.mobile

                var amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1
              }
            }, true)
            break
          // 获取加油站详情
          case "oilStationDetail":
            httper.post("oil/station-detail", requestData, res => {
              this.stationDetail = res.data
              this.request("getUserInfo")
            }, true);
            break;
            // 获取优惠金额
          case "stationprice":
            httper.post("oil/station-price", requestData, res => {
              if (res.code == 0) {
                this.stationprice = res.data
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true);
            break;
            //下单
          case 'sxoilorder':
            httper.post('payment/sx-oil-order', requestData, res => {
              console.log("支付信息", res)
              if (res.code === 0) {
                this.$router.push({
                  path: "orderListDetail",
                  query: {
                    id: res.data.order_no
                  }
                })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信下单
          case 'WxunifiedOrder':
            httper.post('/payment/unified-order', requestData, res => {
              console.log("微信支付信息", res)
              if (res.code === 0) {
                that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信取消下单
          case 'orderCancel':
            httper.post('/order/cancel', requestData, res => {
              console.log("取消", res)
              if (res.code === 0) {
                // that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          this.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //跳去详情页order_no
              that.$router.push({
                path: 'orderListDetail',
                query: {
                  id: order_no
                }
              })
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              this.$toast({
                message: '取消支付'
              })
              this.request("orderCancel", {
                order_id: order_no
              })
              // that.$router.push({
              //   name: 'list'
              // })
            } else {
              this.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },
    }
  }
</script>

<style scoped="scoped">
  .jiayoudetailtop {
    width: 100%;
    height: 134px;
    z-index: 3;
    background: #FD8C00;
  }

  .jiayoudetailcenter {
    background-color: #F7F7F7;
  }

  .jiayoudetailcenter1 {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    position: absolute;
    top: 62px;

  }

  .jiayoudetialbox {
    width: 100%;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 19px 16px;
    box-sizing: border-box;
    margin-bottom: 13px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3000);
  }

  .jiayouboxtop {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .jiayouname {
    font-size: 15px;
    color: #000000;
    font-weight: bold;
  }

  .jiayoujulibox {
    /* width: 69px; */
    height: 25px;
    background: #D2EAF8;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 7px;
    box-sizing: border-box;
  }

  .jiayoujuliicon {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }

  .jiayoujuli {
    font-size: 12px;
    color: #000000;
  }

  .jiayouaddress {
    font-size: 12px;
    color: #666666;
    margin-bottom: 33px;
  }

  .jiayoupricedetail {
    font-size: 27px;
    color: #FD8C00;
    margin-bottom: 17px;
  }

  .jiayouboxbottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .jiayoudetailicon24 {
    width: 69px;
    height: 19px;
    border-radius: 2px;
  }

  .jiayoudetailiconbox {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .jiayoudetailtext {
    font-size: 12px;
    margin-right: 5px;
  }

  .jiayoudetailicon {
    width: 9px;
    height: 9px;
  }

  .jiayoutitle {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 19px;
  }

  .youqianglist {
    width: 100%;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .youqiangbox {
    width: 143px;
    height: 46px;
    background: #D2EAF8;
    border: 2px solid #FD8C00;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

  }

  .youqiangname {
    font-size: 14px;
    color:#FD8C00;
    margin-right: 7px;
  }

  .youqiangbox1 {
    width: 143px;
    height: 46px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #EEEEEE;
    border: 2px solid #EEEEEE;
  }

  .youqiangname1 {
    font-size: 14px;
    color: #000000;
    margin-right: 7px;
  }

  .jiayouinputbox {
    width: 100%;
    height: 46px;
    background: #EEEEEE;
    border-radius: 4px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    padding: 15px;
    box-sizing: border-box;
  }

  .jiayoupriceicon {
    font-size: 14px;
    margin-right: 10px;
  }

  .jiayouinput {
    font-size: 14px;
  }

  input {
    border: none;
    outline: none;
    background-color: #EEEEEE;
  }

  input::-webkit-input-placeholder {
    font-size: 14px;
    color: #666666;
  }

  .jiayoudetailbottom {
    width: 100%;
    padding: 10px 20px 20px 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    background: #FFFFFF;
    box-shadow: 0px -4px 5px 2px rgba(187, 187, 187, 0.3000);
  }

  .detailnone {
    width: 100%;
    height: 50px;
  }

  .jiayoupricebox {
    font-size: 15px;
  }

  .jiayoudetailzhifubotton {
    width: 143px;
    height: 38px;
    background: #FD8C00;
    border-radius: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #FFFFFF;
  }

  .youzhandetailname {
    width: 100%;
    margin: 16px 0 20px 0;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
  }

  .jiayouzhancenter {
    width: calc(100% - 40px);
    margin: 20px;
  }

  .jiayouzhanmesg {
    font-size: 12px;
    margin-bottom: 33px;
  }

  .jiayouzhanimgs {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .jiayouzhanimg {
    width: 31%;
    height: 167px;
  }

  .youqiangtip {
    width: 100%;
    height: 38px;
    background: #FD8C00;
    font-size: 12px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }

  .qianghaolist {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .qianghaobox {
    width: 21%;
    height: 46px;
    background: #D2EAF8;
    border: 2px solid #FD8C00;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 1%;
    margin-bottom: 12px;
    font-size: 15px;
    font-weight: bold;

  }

  .qianghaobox1 {
    width: 21%;
    height: 46px;
    background: #EEEEEE;
    border: 2px solid #EEEEEE;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 1%;
    margin-bottom: 12px;
    font-size: 15px;
    font-weight: bold;

  }

  .youhuibox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .youhuititle {
    font-size: 14px;

  }

  .youhuivalue {
    font-size: 14px;
    color: #FD8C00;
  }
</style>



// WEBPACK FOOTER //
// src/pages/jiayou/jiayouDetail.vue